module.exports = __webpack_public_path__ + "img/1530816627.4f858357.jpg";